import { createContext } from 'react';

/** User-selected preference. `system` follows the OS `prefers-color-scheme`
 *  (and only ever resolves to light/dark — Industrial is a manual choice). */
export type Theme = 'light' | 'dark' | 'industrial' | 'system';

/** The actually-applied appearance after resolving `system`. */
export type ResolvedTheme = 'light' | 'dark' | 'industrial';

/** The themes a user can cycle through explicitly (excludes `system`). */
export const THEME_CYCLE: ResolvedTheme[] = ['light', 'dark', 'industrial'];

export interface ThemeContextValue {
  /** The stored preference (`light` | `dark` | `industrial` | `system`). */
  theme: Theme;
  /** What is currently painted (`system` resolved against the OS). */
  resolvedTheme: ResolvedTheme;
  setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

/** localStorage key — must match the pre-paint script in index.html. */
export const THEME_STORAGE_KEY = 'theme';
